// src/components/Contact/ContactModal.tsx
//
// The connect form presented as an application window.
//
// This file is the whole of the contact-specific composition: which window,
// which title, and what happens when a send succeeds. ModalBox supplies the
// window, ContactForm supplies the form, and neither knows the other's business.
import ModalBox from '../ModalBox/ModalBox';

import ContactForm from './ContactForm';

export interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactModal = ({ isOpen, onClose }: ContactModalProps) => (
  <ModalBox isOpen={isOpen} onClose={onClose} title="Let's Connect" size="md">
    {/*
      onSuccess closes the window, but only once SuccessModal has finished
      showing. The visitor sees the confirmation first, then the window shuts
      and focus returns to whatever opened it — which is the page they were
      already on. Nothing navigates.
    */}
    <ContactForm onSuccess={onClose} />
  </ModalBox>
);

export default ContactModal;
